import React from "react";
import { useHistory } from "react-router-dom";
import ContainerAuthenticated from "containers/Authenticated";
import {
    PageWrapper,
    PageHeader,
    PageTitle,
    PageSubtitle,
    ModeContainer,
    ModeCard,
    PrimaryBadge,
    BonusBadge,
    ModeIcon,
    ModeTitle,
    ModeDescription,
    ModeFeatures,
    ModeCTA,
    SecondaryActions,
    SecondaryLink
} from "./styled";

export default function DashboardModeSelection() {
    const history = useHistory();

    const navigateToMode = (mode) => {
        if (mode === 'conversation') {
            history.push('/dashboard/conversation');
        } else if (mode === 'learning') {
            history.push('/dashboard/learning');
        }
    };

    return (
        <ContainerAuthenticated primary page={'mode-selection'}>
            <PageWrapper>
                <PageHeader>
                    <PageTitle>Como você quer usar o TiqChat hoje?</PageTitle>
                    <PageSubtitle>
                        Escolha o modo que combina com o seu momento.
                    </PageSubtitle>
                </PageHeader>

                <ModeContainer>
                    {/* Modo Bate-papo — destaque principal */}
                    <ModeCard primary onClick={() => navigateToMode('conversation')}>
                        <PrimaryBadge>MAIS USADO</PrimaryBadge>
                        <ModeIcon>💬</ModeIcon>
                        <ModeTitle>Modo Bate-papo</ModeTitle>
                        <ModeDescription>
                            Converse sobre vários temas. Faça perguntas, peça uma sugestão, explore ideias — e veja o que esses personagens têm a dizer.
                        </ModeDescription>
                        <ModeFeatures>
                            <li>Sem julgamentos, sem roteiros</li>
                            <li>Em português ou em mais de 10 idiomas</li>
                            <li>Disponível a qualquer hora</li>
                        </ModeFeatures>
                        <ModeCTA primary>Começar a conversar →</ModeCTA>
                    </ModeCard>

                    {/* Modo Praticar Idiomas — bônus */}
                    <ModeCard onClick={() => navigateToMode('learning')}>
                        <BonusBadge>✨ BÔNUS</BonusBadge>
                        <ModeIcon>📚</ModeIcon>
                        <ModeTitle>Modo Praticar Idiomas</ModeTitle>
                        <ModeDescription>
                            Já estuda inglês, espanhol, hebraico ou outro idioma? Pratique conversação com um personagem bíblico — ele corrige em português.
                        </ModeDescription>
                        <ModeFeatures>
                            <li>Inglês, Espanhol, Francês e mais</li>
                            <li>Hebraico, Grego e Latim — os idiomas originais</li>
                            <li>Correções em português, sem pressão</li>
                        </ModeFeatures>
                        <ModeCTA>Praticar idiomas →</ModeCTA>
                    </ModeCard>
                </ModeContainer>

                <SecondaryActions>
                    <SecondaryLink onClick={() => history.push('/dashboard/history')}>
                        📚 Ver minhas conversas
                    </SecondaryLink>
                </SecondaryActions>
            </PageWrapper>
        </ContainerAuthenticated>
    );
}
